import React, { useEffect, useState, useRef } from 'react';
import { PlusIcon, MinusIcon, HelpCircleIcon } from '../lib/icons';
import { useReveal } from '../lib/useReveal';
const FAQS = [{
  q: '¿Necesito experiencia previa?',
  a: 'No, en absoluto. El MegaPack está diseñado específicamente para guiarte desde cero, paso a paso, sin tecnicismos complejos.'
}, {
  q: '¿Es material digital?',
  a: 'Sí, es 100% digital. Recibís acceso inmediato a todo el contenido para descargarlo o verlo online desde cualquier dispositivo (celular, tablet o PC).'
}, {
  q: '¿Es solo teoría?',
  a: 'No. Aunque tiene una base teórica sólida, el enfoque es totalmente práctico. Incluye ejercicios, meditaciones y guías de aplicación real.'
}, {
  q: '¿Tengo soporte si tengo dudas?',
  a: 'Sí, no estás solo/a en este camino. Tendrás acceso a canales de consulta para resolver cualquier inquietud que surja durante tu aprendizaje.'
}];
function AccordionItem({
  faq,
  isOpen,
  onToggle
}: {
  faq: {
    q: string;
    a: string;
  };
  isOpen: boolean;
  onToggle: () => void;
}) {
  const contentRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);
  useEffect(() => {
    if (contentRef.current) {
      setHeight(isOpen ? contentRef.current.scrollHeight : 0);
    }
  }, [isOpen]);
  return <div className={`border rounded-2xl bg-white overflow-hidden transition-all duration-300 ${isOpen ? 'border-amber-400 shadow-md ring-1 ring-amber-100' : 'border-gray-200 hover:border-amber-200'}`} data-id="element-65">
      <button onClick={onToggle} className="w-full flex items-center justify-between p-6 text-left" data-id="element-66">
        <span className={`font-bold text-lg transition-colors ${isOpen ? 'text-amber-900' : 'text-gray-900'}`} data-id="element-67">
          {faq.q}
        </span>
        <span className={`flex-shrink-0 ml-4 p-1 rounded-full transition-colors ${isOpen ? 'bg-amber-100 text-amber-600' : 'bg-gray-100 text-gray-400'}`} data-id="element-68">
          {isOpen ? <MinusIcon className="w-5 h-5" data-id="element-69" /> : <PlusIcon className="w-5 h-5" data-id="element-70" />}
        </span>
      </button>
      <div ref={contentRef} style={{
      maxHeight: height
    }} className="overflow-hidden transition-all duration-300 ease-in-out" data-id="element-71">
        <div className="px-6 pb-6 text-gray-600 text-lg leading-relaxed border-t border-gray-100 pt-4 bg-gray-50/50" data-id="element-72">
          {faq.a}
        </div>
      </div>
    </div>;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#f0eaf7] py-24 md:py-32 px-4" data-id="element-73">
      <div className="container mx-auto max-w-3xl" data-id="element-74">
        <div className="text-center mb-16" data-id="element-75">
          <div className="inline-flex items-center justify-center w-12 h-12 bg-amber-100 rounded-full mb-4 text-amber-600" data-id="element-76">
            <HelpCircleIcon className="w-6 h-6" data-id="element-77" />
          </div>
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-gray-900 leading-tight" data-id="element-78">
            Preguntas frecuentes
          </h2>
        </div>

        <div ref={ref1} className={`reveal space-y-4 ${vis1 ? 'is-visible' : ''}`} data-id="element-79">
          {FAQS.map((faq, idx) => <AccordionItem key={idx} faq={faq} isOpen={openIndex === idx} onToggle={() => setOpenIndex(openIndex === idx ? null : idx)} data-id="element-80" />)}
        </div>
      </div>
    </section>;
}